<div class="multi-action" [ngClass]="{'multi-action-column' : isSidePanel}">
  <div class="multi-action_form" [formGroup]="settingsForm">
    <div class="multi-action_container">
      <div class="input-container">
        <div class="input-container_label">Repricing Model</div>
        <select
          class="input-container_input input-container_input--thin"
          formControlName="value"
        >
          <option value="" disabled selected>Select</option>
          <option
            *ngFor="let option of repricingModels"
            [value]="option.modelId"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="multi-action_switch">
        <mat-slide-toggle formControlName="isOn"
          class="mat-slide-toggle-sm"
        >On
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <div class="multi-action_form" [formGroup]="priceForm">
    <div
      class="multi-action_container"
      *ngFor="let price of sku.priceBreakdown"
      [formGroupName]="price.name"
    >
      <div class="input-container">
        <div class="input-container_label">{{ price.name }}</div>
        <div class="input-container_wrapper">
          <input
            type="number"
            class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
            formControlName="value"
            appDecimalNumber="2"
            min="0"
            step="any"
            [ngClass]="{ hasError: price.hasError === true }"
          />
          <span class="input-container_icon input-container_icon--small">
            <i
              class="fa"
              [ngClass]="
                price.name !== 'Markup' ? 'fa-dollar-sign' : 'fa-percent'
              "
            ></i>
          </span>
        </div>
        <mat-radio-group class="custom-mat-radio mt-1 d-block" *ngIf="price.name === 'Markup'" aria-label="Select an option" [formControl]="markupType">
          <mat-radio-button class="me-2" value="1">MarkUp</mat-radio-button>
          <mat-radio-button class="me-2" value="2">Margin</mat-radio-button>
          <mat-radio-button class="me-2" value="3">Amount</mat-radio-button>
        </mat-radio-group>
      </div>
      <div
        class="multi-action_switch"
        *ngIf="!disableAutoFields.includes(price.name)"
      >
        <mat-slide-toggle [checked]="priceForm.controls[price.name].get('configType').value == 'Auto'" (change)="setValue(price.name, $event.checked ? 'Auto' : 'Overridden')"
          class="mat-slide-toggle-sm">{{ price.name === 'Map Price' ? 'On' : 'Auto'}}
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="price.name !== 'Map Price'" [checked]="priceForm.controls[price.name].get('configType').value == 'Overridden'" (change)="setValue(price.name,$event.checked ? 'Overridden' : 'Auto')"
          class="mat-slide-toggle-sm"> Manual
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<div class="multi-action_confirm footer" [ngClass]="{'footer-fixed' : isSidePanel}">   
  <app-button (click)="view()">Cancel</app-button>
  <app-button
    [spin]="isLoading"
    [isDisabled]="settingsForm.invalid || priceForm.invalid"
    (click)="save()"
    >Save</app-button
  >
</div>